/**
 * @file 投票服务
 * @author fuqiang15
 */

import FormModel from '../BaseFormModel';

export default class VoteServiceDetailModel extends FormModel {
    /**
     * @override
     */
    title = '';

    serviceType = 'vote';

    voteTypeMap = {
        single: '单选',
        multiple: '多选'
    };

    adaptData(data) {
        data.data = data.serviceData;
        let [rangeMin, rangeMax] = data.data.type.split(',');
        data.rangeMin = rangeMin;
        data.rangeMax = rangeMax;
        data.rangeType = rangeMin === rangeMax ? 'single' : 'multiple';
        if (data.data.options) {
            data.options = data.data.options.join('\n');
        }
        return super.adaptData(data);
    }
}
